var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoleto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.708,
    height: 30.722,
    viewBox: "0 0 47.708 30.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3609",
    "data-name": "Grupo 3609",
    transform: "translate(-11.043 -8.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1042",
    "data-name": "Caminho 1042",
    d: "M590.014,26.612c1.192,0,2.345-.013,3.5.018.128,0,.262.241.366.39.041.059.008.17.008.257q0,9.809,0,19.617c0,.171-.018.343-.03.56h-3.839Z",
    transform: "translate(-554.554 -17.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1043",
    "data-name": "Caminho 1043",
    d: "M526.711,47.466h-3.129V26.631c.957,0,1.931-.008,2.9.013.093,0,.2.174.267.287.039.065.012.17.012.258q0,9.9,0,19.8a4.529,4.529,0,0,1-.051.475",
    transform: "translate(-509.971 -17.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1044",
    "data-name": "Caminho 1044",
    d: "M575.259,26.573V47.433h-2.342v-.7c0-6.472.008-12.944-.013-19.415,0-.6.161-.816.765-.758.512.049,1.033.01,1.59.01",
    transform: "translate(-543.071 -17.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1550",
    "data-name": "Ret\\xE2ngulo 1550",
    width: 2.226,
    height: 20.824,
    transform: "translate(52.465 8.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1551",
    "data-name": "Ret\\xE2ngulo 1551",
    width: 1.188,
    height: 30.65,
    transform: "translate(11.043 8.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1552",
    "data-name": "Ret\\xE2ngulo 1552",
    width: 1.115,
    height: 30.607,
    transform: "translate(57.636 8.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1045",
    "data-name": "Caminho 1045",
    d: "M608.293,26.641V47.473h-1.5v-.815q0-9.517,0-19.035c0-1.109-.175-1,1.01-1.008.149,0,.3.015.486.026",
    transform: "translate(-565.812 -17.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1046",
    "data-name": "Caminho 1046",
    d: "M524.324,103.191V95.772c1.468,0,2.9-.054,4.334.022a1.626,1.626,0,0,1,1.495,1.286,1.849,1.849,0,0,1-.872,2.133,2.016,2.016,0,0,1,1.3,1.581,2.057,2.057,0,0,1-1.953,2.381c-1.412.072-2.831.016-4.3.016m1.562-1.246c.758,0,1.452.015,2.145,0,.563-.016.964-.252.995-.884a.9.9,0,0,0-.915-1.043c-.724-.07-1.46-.016-2.224-.016Zm0-4.951v1.67c.721,0,1.409.027,2.094-.009A.827.827,0,0,0,527.945,97c-.666-.032-1.334-.008-2.058-.008",
    transform: "translate(-510.468 -64.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1047",
    "data-name": "Caminho 1047",
    d: "M553.77,99.1c-.048,2.634-1.483,4.027-3.939,3.93a3.333,3.333,0,0,1-3.3-3.023,6.815,6.815,0,0,1,.073-2.013,3.267,3.267,0,0,1,3.661-2.728,3.364,3.364,0,0,1,3.422,2.9c.058.343.065.694.086.935m-5.763-.125a11.044,11.044,0,0,0,.132,1.119,1.96,1.96,0,0,0,1.989,1.631,1.864,1.864,0,0,0,1.951-1.652,6.453,6.453,0,0,0-.06-2.124,1.689,1.689,0,0,0-1.674-1.386,1.868,1.868,0,0,0-2.049,1.166,7.712,7.712,0,0,0-.29,1.247",
    transform: "translate(-525.342 -63.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1048",
    "data-name": "Caminho 1048",
    d: "M634.668,95.244c2.246,0,3.654,1.487,3.664,3.863.01,2.425-1.382,3.909-3.669,3.913-2.26,0-3.655-1.47-3.649-3.857.006-2.455,1.373-3.921,3.654-3.919m-2.145,3.841a11.36,11.36,0,0,0,.269,1.293,1.866,1.866,0,0,0,1.879,1.332,1.889,1.889,0,0,0,1.883-1.331,3.869,3.869,0,0,0,0-2.56,1.808,1.808,0,0,0-1.842-1.279,1.848,1.848,0,0,0-1.886,1.223,11.123,11.123,0,0,0-.3,1.322",
    transform: "translate(-582.07 -63.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1049",
    "data-name": "Caminho 1049",
    d: "M591.885,95.766h5.488V97H593.4v1.657h3.7v1.265H593.4v2.062h4.115v1.208h-5.635Z",
    transform: "translate(-555.81 -64.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1553",
    "data-name": "Ret\\xE2ngulo 1553",
    width: 1.13,
    height: 20.823,
    transform: "translate(26.697 8.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1554",
    "data-name": "Ret\\xE2ngulo 1554",
    width: 1.065,
    height: 20.814,
    transform: "translate(21.195 8.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1555",
    "data-name": "Ret\\xE2ngulo 1555",
    width: 1.056,
    height: 20.814,
    transform: "translate(43.773 8.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1556",
    "data-name": "Ret\\xE2ngulo 1556",
    width: 1.081,
    height: 20.833,
    transform: "translate(55.249 8.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1050",
    "data-name": "Caminho 1050",
    d: "M559.869,26.7h.728V47.53l-.728.037Z",
    transform: "translate(-534.323 -17.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1557",
    "data-name": "Ret\\xE2ngulo 1557",
    width: 0.707,
    height: 20.826,
    transform: "translate(24.336 8.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1558",
    "data-name": "Ret\\xE2ngulo 1558",
    width: 0.687,
    height: 20.813,
    transform: "translate(33.106 8.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1559",
    "data-name": "Ret\\xE2ngulo 1559",
    width: 0.709,
    height: 20.819,
    transform: "translate(49.271 8.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1051",
    "data-name": "Caminho 1051",
    d: "M613.756,96.989h-2.187V95.765h5.865v1.209h-.9c-1.29,0-1.29,0-1.29,1.318v4.89h-1.487Z",
    transform: "translate(-569.02 -64.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1052",
    "data-name": "Caminho 1052",
    d: "M572.439,103.28V95.9h1.439c.012.227.034.456.035.686,0,1.308,0,2.616,0,3.923,0,1.582,0,1.582,1.617,1.582h2.116v1.192Z",
    transform: "translate(-542.759 -64.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1053",
    "data-name": "Caminho 1053",
    d: "M625.06,26.7h.6V47.521l-.6.052Z",
    transform: "translate(-578.074 -17.921)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoleto);
export default __webpack_public_path__ + "static/media/boleto.3244d7f7e331ad4aac961192990c4863.svg";
export { ForwardRef as ReactComponent };